var styles = [
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#CACAD2" }]
  },
  {
    featureType: "road.highway",
    elementType: "labels.icon",
    stylers: [{ hue: "#CACAD2" }, { lightness: 50 }]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text",
    stylers: [{ color: "#687077" }]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ lightness: 100 }, { visibility: "simplified" }]
  },
  {
    featureType: "road",
    stylers: [{ visibility: "simplified" }]
  },
  {
    featureType: "poi",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi.park",
    stylers: [{ visibility: "on", color: "#CADEAD" }]
  },
  {
    featureType: "landscape.man_made",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "landscape",
    stylers: [{ color: "#F8E9DB" }]
  },
  {
    featureType: "road.local",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }]
  }
];

const GoogleMap = {
  mapOptions: {
    zoom: 12,
    zoomControl: true,
    zoomControlOptions: {
      style: google.maps.ZoomControlStyle.DEFAULT
    },
    scrollwheel: false,
    disableDefaultUI: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: styles
  },

  marker: {
    min: [12, 12],
    max: [20, 20]
  },

  "offsite-amenities": {
    min: [105, 18],
    max: [105, 18]
  },

  home: {
    min: [147, 18],
    max: [147, 18]
  },

  initialize: function(locations, home, pinStyles) {
    this.locations = locations;

    this.initialLatitude = parseFloat(home[1]) + 0.0015;
    this.initialLongitude = parseFloat(home[2]);

    this.mapOptions.center = {
      lat: this.initialLatitude,
      lng: this.initialLongitude
    };

    this.map = new google.maps.Map(
      document.getElementById("map-canvas"),
      this.mapOptions
    );

    this.infowindow = new google.maps.InfoWindow();

    google.maps.event.addListener(this.infowindow, "closeclick", function() {
      jQuery(".places-column li").removeClass("current");
    });

    function pinImage(x) {
      return pinStyles[locations[x][6]] || pinStyles["default"];
    }

    var marker, i;

    var self = this;

    for (i = 0; i < locations.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: this.map,
        icon: pinImage(i)
      });

      locations[i].push(marker);

      google.maps.event.addListener(
        marker,
        "click",
        (function(marker, i) {
          return function() {
            var parts = [];

            parts.push("<div id='scrollbar_container'>");
            parts.push("<div id='scrollbar_content'>");
            parts.push(
              "<span>" + locations[i][0] + "</span><br />" + locations[i][3]
            );
            parts.push("</div>");

            var newContent = parts.join("");

            self.infowindow.setContent(newContent);
            self.infowindow.open(self.map, marker);

            google.maps.event.addListener(
              self.infowindow,
              "domready",
              function() {
                var container = jQuery("scrollbar_container");
                // new Control.ScrollBar('scrollbar_content','scrollbar_track');
              }
            );
          };
        })(marker, i)
      );
    }

    google.maps.event.addListener(
      this.map,
      "zoom_changed",
      this.resizeMarkers.bind(this)
    );

    this.resizeMarkers();

    google.maps.event.addListener(this.map, "center_changed", function() {
      var size = [this.getDiv().offsetWidth, this.getDiv().offsetHeight].join(
        "x"
      );

      if (!this.get("size") || size === this.get("size")) {
        this.setValues({
          size: size,
          _center: this.getCenter()
        });
      } else {
        google.maps.event.addListenerOnce(this, "idle", function() {
          this.setValues({
            size: size,
            center: this.get("_center")
          });
        });
      }
    });

    google.maps.event.trigger(this.map, "center_changed", {});

    jQuery(".places-column li").click(function() {
      var place = jQuery(this).data("place"),
        map = jQuery("#poi-map"),
        offset_y = map.offset().top - 55;

      jQuery("body, html").animate({ scrollTop: offset_y });
      jQuery(".places-column li").removeClass("current");
      jQuery(this).addClass("current");

      self.openBalloon(place);
    });
  },

  resizeMarkers: function() {
    var zoom = Math.max(this.map.getZoom() - this.mapOptions.zoom, 0);

    for (var i = 0; i < this.locations.length; i++) {
      if (this.locations[i][6] === "home") {
        var kind = "home";
      } else if (this.locations[i][6] === "offsite-amenities") {
        var kind = "offsite-amenities";
      } else {
        var kind = "marker";
      }

      var min = this[kind].min;
      var max = this[kind].max;

      var width = this.sizeFromZoom(min[0], max[0], zoom);
      var height = this.sizeFromZoom(min[1], max[1], zoom);

      var marker = this.locations[i][7];
      var size = new google.maps.Size(width, height);
      var icon = marker.getIcon();
      var url = icon.url;
      var anchor = icon.anchor || new google.maps.Point(height / 2, height / 2);
      var image = {
        url: url,
        scaledSize: size,
        anchor: anchor
      };

      marker.setIcon(image);
    }
  },

  sizeFromZoom: function(min, max, zoom) {
    return Math.min(max, Math.round(min * Math.pow(2, zoom)));
  },

  setMapForMarkers: function(category_slug) {
    for (var i = 0; i < this.locations.length; i++) {
      var map_to_use =
        this.locations[i][6] == category_slug || this.locations[i][6] == "home"
          ? this.map
          : null;
      this.locations[i][7].setMap(map_to_use);
    }
  },

  openBalloonFromHash: function() {
    if (window.location.hash) {
      this.openBalloon(window.location.hash);
    }
  },

  openBalloon: function(locationName) {
    var locations = this.locations;

    for (var i = 0; i < locations.length; i++) {
      var loc = locations[i];
      var marker = loc[7];

      // Set current_location
      var current_location = loc[5];

      // Check for match between hash and location
      // and pop up a balloon if they do
      if (String(locationName) === current_location) {
        var parts = [];

        parts.push("<div id='scrollbar_container'>");
        parts.push("<div id='scrollbar_content'>");
        parts.push(
          "<span>" + locations[i][0] + "</span><br />" + locations[i][3]
        );
        parts.push("</div>");

        var newContent = parts.join("");

        this.infowindow.setContent(newContent);
        this.infowindow.open(this.map, marker);

        google.maps.event.addListener(this.infowindow, "domready", function() {
          var container = jQuery("scrollbar_container");
        });
      }
    }
  }
};

export default GoogleMap;



// WEBPACK FOOTER //
// ./app/javascript/modules/googleMap.js